import { FieldFilter, GetAndPost, SearchOperator } from "lib/api"
import * as enm from "lib/enum"

interface filterOptions<FieldType extends Key> {
	field: FieldType
	label: string
	multiple?: boolean
}

interface dropdownOptions<FieldType extends Key, I, O = I> extends filterOptions<FieldType> {
	getter: (api: GetAndPost<I[]>) => Promise<O[]>
}

interface filterTypes<FieldType extends Key, I, O = I> {
	Text: filterOptions<FieldType>
	Dropdown: dropdownOptions<FieldType, I, O>
	Date: filterOptions<FieldType>
}

export type Key = string | number | symbol

export class FilterEnum<FieldType extends Key, I, O = I> extends enm.Variant<
	filterTypes<FieldType, I, O>
> {
	static Text<FieldType extends string, I, O = I>(
		props: filterOptions<FieldType>
	): FilterEnum<FieldType, I, O> {
		return new FilterEnum("Text", props)
	}

	static Dropdown<FieldType extends string, I, O = I>(
		props: dropdownOptions<FieldType, I, O>
	): FilterEnum<FieldType, I, O> {
		return new FilterEnum("Dropdown", props)
	}

	static Date<FieldType extends string, I, O = I>(
		props: filterOptions<FieldType>
	): FilterEnum<FieldType, I, O> {
		return new FilterEnum("Date", props)
	}

	GetFieldFilter(
		part: Partial<FieldFilter<Record<FieldType, string>>>
	): FieldFilter<Record<FieldType, string>> {
		return this.Match({
			Dropdown: (d) => ({
				fieldName: d.field,
				filterOperator: "startswithcaseinsensitive" as SearchOperator,
				filterValueList: [],
				filterValue: "",
				...part,
			}),
			_: () => ({
				fieldName: this.Data.field,
				filterOperator: "contains" as SearchOperator,
				filterValueList: [],
				filterValue: "",
				...part,
			}),
		})
	}

	IsFilterKey(k: string): bool {
		return this.Data.field.String().Equal(k) || this.Data.field.String().Equal("q")
	}
}

export const Text = FilterEnum.Text
export const Dropdown = FilterEnum.Dropdown
export const Date = FilterEnum.Date
